import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import MarkdownRenderer from '../../components/MarkdownRenderer';
import ExampleList from '../../components/ExampleList';

class Buttons extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }

        this.props.includeNav();
    }

    render() {

        const basicClasses = [
          {
            text: 'Default Button',
            markdown: '`<button>button</button>` or `<div class="btn">button</div>`'
          },{
            text: 'Primary Button',
            markdown: '`<button class="btn-primary">small button</button>`'
          },{
            text: 'Secondary Button',
            markdown: '`<button class="btn-secondary">small button</button>`'
          },{
            text: 'Input Type=Submit',
            markdown: '`<input type="submit" id="submitButton" name="submitButton" value="Input: Submit">`'
          },{
            text: 'Disabled Button',
            markdown: '`<button class="btn-disabled">small button</button>`'
          }
        ]

        const smallClasses = [
          {
            text: 'Small Button',
            markdown: '`<button class="btn-small">small button</button>` or `<div class="btn btn-small">small button</div>`'
          },{
            text: 'Small Primary',
            markdown: '`<button class="btn-small btn-primary">small primary button</button>`'
          },{
            text: 'Small Secondary',
            markdown: '`<button class="btn-small btn-secondary">small secondary button</button>`'
          },{
            text: 'Small Disabled',
            markdown: '`<button class="btn-small btn-disabled">small disabled button</button>`'
          }
        ]

        const loadingClasses = [
          {
            text: 'Loading Button',
            markdown: '`<button class="btn-loading">loading button</button>` or `<div class="btn btn-loading">loading button</div>`'
          },{
            text: 'Loading Primary',
            markdown: '`<button class="btn-loading btn-primary">loading primary button</button>`'
          },{
            text: 'Loading Secondary',
            markdown: '`<button class="btn-loading btn-secondary">loading secondary button</button>`'
          }
        ]

        const centeredClasses = [
          {
            text: 'Centered Button',
            markdown: '`<button class="btn-centered">centered button</button>` or `<div class="btn btn-centered">centered button</div>`'
          },{
            text: 'Centered Primary',
            markdown: '`<button class="btn-centered btn-primary">centered primary button</button>`'
          },{
            text: 'Centered Secondary',
            markdown: '`<button class="btn-centered btn-secondary">centered secondary button</button>`'
          }
        ]

        const crudClasses = [
          {
            text: 'Create Button',
            markdown: '`<button class="btn-create">create</button>`'
          },{
            text: 'Edit Button',
            markdown: '`<button class="btn-edit">edit</button>`'
          },{
            text: 'Save Button',
            markdown: '`<button class="btn-save">save</button>`'
          },{
            text: 'Delete Button',
            markdown: '`<button class="btn-delete">delete</button>`'
          }
        ]

        const crudSmallClasses = [
          {
            text: 'Small Create',
            markdown: '`<button class="btn-create btn-small">create</button>`'
          },{
            text: 'Small Edit',
            markdown: '`<button class="btn-edit btn-small">edit</button>`'
          },{
            text: 'Small Save',
            markdown: '`<button class="btn-save btn-small">save</button>`'
          },{
            text: 'Small Delete',
            markdown: '`<button class="btn-delete btn-small">delete</button>`'
          }
        ]

        const crudLoadingClasses = [
          {
            text: 'Loading Create',
            markdown: '`<button class="btn-create btn-loading">create</button>`'
          },{
            text: 'Loading Edit',
            markdown: '`<button class="btn-edit btn-loading">edit</button>`'
          },{
            text: 'Loading Save',
            markdown: '`<button class="btn-save btn-loading">save</button>`'
          },{
            text: 'Loading Delete',
            markdown: '`<button class="btn-delete btn-loading">delete</button>`'
          }
        ]

        const crudTertiaryClasses = [
          {
            text: 'Tertiary Create',
            markdown: '`<button class="btn-create btn-tertiary">create</button>`'
          },{
            text: 'Tertiary Edit',
            markdown: '`<button class="btn-edit btn-tertiary">edit</button>`'
          },{
            text: 'Tertiary Save',
            markdown: '`<button class="btn-save btn-tertiary">save</button>`'
          },{
            text: 'Tertiary Delete',
            markdown: '`<button class="btn-delete btn-tertiary">delete</button>`'
          }
        ]

        const crudSmallTertiaryClasses = [
          {
            text: 'Small Tertiary Create',
            markdown: '`<button class="btn-create btn-tertiary btn-small">create</button>`'
          },{
            text: 'Small Tertiary Edit',
            markdown: '`<button class="btn-edit btn-tertiary btn-small">edit</button>`'
          },{
            text: 'Small Tertiary Save',
            markdown: '`<button class="btn-save btn-tertiary btn-small">save</button>`'
          },{
            text: 'Small Tertiary Delete',
            markdown: '`<button class="btn-delete btn-tertiary btn-small">delete</button>`'
          }
        ]

        return (
            <DocumentTitle
                title={'BCS Documentation - Buttons'}>
                <section className="page" data-component="buttons">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Buttons</h1>
                            <p>It is best to use the native HTML <MarkdownRenderer text={'`<button></button>`'} inline={true}/> element for all buttons. In the rare case that a non-button element is needed be sure to include the <MarkdownRenderer text={'`role="button"`'} inline={true}/> attribute and to optionally add the <MarkdownRenderer text={'`.btn`'} inline={true}/> class to said element.</p>
                        </div>
                        <div className="col-xs-12">
                            <h2>Full Size</h2>
                            <button>Button</button>
                            <button className="btn-primary">Primary Button</button>
                            <button className="btn-secondary">Secondary Button</button>
                            <input type="submit" name="" value="Input: Submit"/>
                            <button disabled="true">Disabled Button</button>
                            <ExampleList title="Basic Button Examples" list={basicClasses}/>
                            <h2>Small</h2>
                            <button className="btn-small">Small Button</button>
                            <button className="btn-primary btn-small">Small Primary Button</button>
                            <button className="btn-secondary btn-small">Small Secondary Button</button>
                            <button disabled="true" className="btn-small">Small Disabled Button</button>
                            <ExampleList title="Small Button Examples" list={smallClasses}/>
                            <h2>Loading</h2>
                            <button className="btn-loading">Button</button>
                            <button className="btn-primary btn-loading">Primary Button</button>
                            <button className="btn-secondary btn-loading">Secondary Button</button>
                            <ExampleList title="Loading Button Examples" list={loadingClasses}/>
                            <hr/>
                            <h2>Centered</h2>
                            <button className="btn-center">Centered Button</button>
                            <button className="btn-primary btn-center">Centered Primary Button</button>
                            <button className="btn-secondary btn-center">Centered Secondary Button</button>
                            <ExampleList title="Centered Button Examples" list={centeredClasses}/>
                            <hr/>
                            <h2>C.R.U.D. Operations</h2>
                            <button className="btn-create">Create</button>
                            <button className="btn-edit">Edit</button>
                            <button className="btn-save">Save</button>
                            <button className="btn-delete">Delete</button>
                            <ExampleList title="C.R.U.D. Button Examples" list={crudClasses}/>
                            <hr/>
                            <h2>C.R.U.D. Operations Small</h2>
                            <button className="btn-create btn-small">Create</button>
                            <button className="btn-edit btn-small">Edit</button>
                            <button className="btn-save btn-small">Save</button>
                            <button className="btn-delete btn-small">Delete</button>
                            <ExampleList title="Small C.R.U.D. Button Examples" list={crudSmallClasses}/>
                            <hr/>
                            <h2>C.R.U.D. Operations Loading</h2>
                            <button className="btn-create btn-loading">Create</button>
                            <button className="btn-edit btn-loading">Edit</button>
                            <button className="btn-save btn-loading">Save</button>
                            <button className="btn-delete btn-loading">Delete</button>
                            <ExampleList title="Loading C.R.U.D. Button Examples" list={crudLoadingClasses}/>
                            <hr/>
                            <h2>C.R.U.D. Operations Tertiary</h2>
                            <button className="btn-create btn-tertiary">Create</button>
                            <button className="btn-edit btn-tertiary">Edit</button>
                            <button className="btn-save btn-tertiary">Save</button>
                            <button className="btn-delete btn-tertiary">Delete</button>
                            <ExampleList title="Tertiary C.R.U.D. Button Examples" list={crudTertiaryClasses}/>
                            <hr/>
                            <h2>C.R.U.D. Operations Small Tertiary</h2>
                            <button className="btn-create btn-small btn-tertiary">Create</button>
                            <button className="btn-edit btn-small btn-tertiary">Edit</button>
                            <button className="btn-save btn-small btn-tertiary">Save</button>
                            <button className="btn-delete btn-small btn-tertiary">Delete</button>
                            <ExampleList title="Small Tertiary C.R.U.D. Button Examples" list={crudSmallTertiaryClasses}/>
                            <hr/>
                            <h2>Button Groups</h2>
                            <div className="btn-group">
                                <button>Button 1</button><button>Button 2</button>
                            </div>
                            <div className="btn-group">
                                <button className="btn-small">Button 1</button><button className="btn-small">Button 2</button><button className="btn-small">Button 3</button>
                            </div>
                            <div className="btn-group">
                                <button className="btn-submit">Submit</button><button className="btn-delete">Cancel</button>
                            </div>
                            <div className="btn-group">
                                <button className="btn-save">Save</button><button className="btn-delete">Cancel</button>
                            </div>
                            <div className="btn-group">
                                <button className="btn-save btn-small">Save</button><button className="btn-edit btn-small">Clear</button><button className="btn-delete btn-small">Cancel</button>
                            </div>
                            <div className="bcs-mardown">
                              Wrap any number of buttons that can fit in a horizontal row within a <MarkdownRenderer text={'`<div class="btn-group"></div>`'} inline={true}/> container.
                            </div>
                        </div>
                    </div>
                </section>
            </DocumentTitle>
        )
    }
}

export default Buttons;



// WEBPACK FOOTER //
// ./src/pages/Buttons/index.js